import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7006Model } from '../kymw7006.model';
import { FeatureRequest } from '../vo/feature-request.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

// レスポンス構造
type GetRequestInfoListResponse = {
  OrderCode: string;
  MediumType: string;
  MediumTypeName: string;
  FeatureGoodsRequestId: number;
  RequestStatus: number;
  RequestStatusName: string;
  RequestType: number;
  RequestTypeName: string;
  FeatureCode: string;
  FeatureName: string;
  ClassCode: string;
  ClassCodeName: string;
  MiddleClassCode: string;
  MiddleClassCodeName: string;
  PCode: string;
  GuideGoodsName: string;
  GuideStandardName: string;
  TagName: string;
  ThisTimeSupplyPrice: number;
  PricePattern: number;
  PricePatternName: string;
  PlanNumAiPrediction: number;
  PlanNum: number;
  PlanSupplyBudget: number;
  ThisTimeCostPrice: number;
  Gpr: number;
  RequestBuyerUserId: string;
  RequestBuyerUserName: string;
}[];

/**
 * 依頼一覧情報取得サービス
 * @export GetRequestInfoListService
 * @class GetRequestInfoListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetRequestInfoListService extends PlessJsonResponderSub<GetRequestInfoListResponse> {
  model: KYMW7006Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetRequestInfoListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.model.orderCode,
        MediumType: this.model.mediumType,
        ClassCode: this.model.classCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetRequestInfoListService
   */
  execute(model: KYMW7006Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('getRequestInfoList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetRequestInfoListService
   */
  success(data: GetRequestInfoListResponse) {
    this.model.featureRequestList = data.map(_ => new FeatureRequest(
      _.OrderCode,
      _.MediumType,
      _.MediumTypeName,
      _.FeatureGoodsRequestId,
      _.RequestStatus,
      _.RequestStatusName,
      _.RequestType,
      _.RequestTypeName,
      _.FeatureCode,
      _.FeatureName,
      PlessViewUtilsSub.toDisplayCodeAndName(_.FeatureCode, _.FeatureName),
      _.ClassCode,
      _.ClassCodeName,
      PlessViewUtilsSub.toDisplayCodeAndName(_.ClassCode, _.ClassCodeName),
      _.MiddleClassCode,
      _.MiddleClassCodeName,
      PlessViewUtilsSub.toDisplayCodeAndName(_.MiddleClassCode, _.MiddleClassCodeName),
      _.PCode,
      _.GuideGoodsName,
      _.GuideStandardName,
      _.TagName,
      _.ThisTimeSupplyPrice,
      _.PricePattern,
      _.PricePatternName,
      _.PlanNumAiPrediction,
      _.PlanNum,
      _.PlanSupplyBudget,
      this.model.setDispPlanSupplyBudget(_.PlanSupplyBudget),
      _.ThisTimeCostPrice,
      _.Gpr,
      _.RequestBuyerUserId,
      _.RequestBuyerUserName,
    ));
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
